import { FunctionComponent } from 'react'

import styled, { css } from 'styled-components'

import translate from '@i18n'

const InfoBox = styled.div`
  ${({
    theme: {
      colors: { fillWeak },
      spacing: { spacing16, spacing24 },
      typography: {
        bodycopy: {
          small2: { bundledCSS: bodycopySmall2CSS },
        },
      },
    },
  }) => {
    return css`
      box-sizing: border-box;
      padding: ${spacing16};
      margin-top: ${spacing24};
      background-color: ${fillWeak};
      ${bodycopySmall2CSS};
    `
  }}
`

const CommentingInfoBox: FunctionComponent = () => {
  return <InfoBox>{translate('commenting.noAvailableComments')}</InfoBox>
}

export default CommentingInfoBox
